import { FC, PropsWithChildren } from "react";
import { Box, BoxProps, Flex, Image } from "@chakra-ui/react";
import { GreyBox, Heading, SectionContainer, ParallaxImage, TextContent, useIsMobile } from "./shared";

const imageWidth = { base: "auto", md: "428px", lg: "484px", xl: "536px", "2xl": "624px" };

const HeroText = () => (
  <Box px={12} pt={{ base: 12, md: 16 }} pb={{ base: 0, md: 16 }} maxWidth={{ base: "auto", md: "calc(50% + 64px)" }}>
    <Heading>Analytics.</Heading>
    <Heading mb={8} whiteSpace="nowrap">
      For{" "}
      <Heading as="span" fontStyle="italic">
        Everything.
      </Heading>
    </Heading>
    <TextContent mb={8}>
      Want to see how your portfolio performed over the past month? How many profits you&apos;ve locked in this week? Or
      how your collection breakdown looks?
    </TextContent>
    <TextContent>You&apos;re only ever a tap of a button away from rich insights into your portfolio.</TextContent>
  </Box>
);

const Phone: FC<PropsWithChildren<BoxProps>> = (props) => (
  <Box position="relative" {...props}>
    <Image src="/images/app-landing-page/analytics-phone.png" alt="analytics-phone" />
    <Box position="absolute" top={0} right={0} height="100%" width="100%">
      <ParallaxImage
        src="/images/app-landing-page/analytics-pane-1.png"
        alt="analytics-pane-1"
        parallaxProps={{ translateX: ["50px", "0px"] }}
      />
      <ParallaxImage
        src="/images/app-landing-page/analytics-pane-2.png"
        alt="analytics-pane-2"
        parallaxProps={{ translateX: ["-50px", "0px"] }}
      />
      <ParallaxImage
        src="/images/app-landing-page/analytics-pane-3.png"
        alt="analytics-pane-3"
        parallaxProps={{ translateX: ["50px", "0px"] }}
      />
      <ParallaxImage
        src="/images/app-landing-page/analytics-pane-4.png"
        alt="analytics-pane-4"
        parallaxProps={{ translateX: ["-50px", "0px"] }}
      />
    </Box>
  </Box>
);

const MobileAnalytics = () => (
  <SectionContainer baseMaxWidth="390px">
    <GreyBox>
      <HeroText />
      <Phone />
    </GreyBox>
  </SectionContainer>
);

export const Analytics = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileAnalytics />;
  }

  return (
    <SectionContainer>
      <Flex position="relative" justifyContent="end">
        <GreyBox position="absolute" left={0} top="50%" transform="translateY(-50%)" width="100%">
          <HeroText />
        </GreyBox>
        <Phone width={imageWidth} />
      </Flex>
    </SectionContainer>
  );
};
